import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { palette } from "../../styles/palette";
import { setShowErrorModal } from "../../reducers/app";
import { useDispatch, useSelector } from "react-redux";
import { ErrorIcon } from "../../assets/icons/ErrorIcon";
import { errorModalMessageSelector } from "../../reducers/app/selector";

const ErrorContainer = styled(Box)({
    width: "20%",
    minHeight: "10%",
    position: "absolute",
    padding: "0.5rem",
    top: "15%",
    left: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: palette.dpdRed,
    border: `2px solid ${palette.typography.white.solid}`,
    borderRadius: "10px",
    color: palette.typography.white.solid,
    zIndex: "9998",
});

export const ErrorModal = () => {
  const dispatch = useDispatch();
  const errorMessage = useSelector(errorModalMessageSelector);

  useEffect(() => {
    setTimeout(() => {
      dispatch(setShowErrorModal(false));
    }, 6000);
  }, [dispatch]);

  return (
    <ErrorContainer>
      <ErrorIcon />
      <Typography variant={"body1"}>ERROR: {errorMessage}</Typography>
      <Typography variant={"body1"}>Please try again later</Typography>
    </ErrorContainer>
  );
};
